/* jshint undef: true, unused: true */
/* globals txt */

'use strict';

var naranjoTotalScore = require('./dropdown-options/medications__naranjo-total-score.js');
const getVisibleClientFields = require("./medications-visible-client-fields");

function formBuilderStructure () {

  var structure = {
    medicationId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name : 'medicationId'
      }
    },
    answersId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name : 'answersId'
      }
    },
    administeredHeading : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : ['meds-key-row', 'grid-row'],
      attributes   : {
        id : 'section-title-row'
      },
      inputChildren : {
        emptyColumn : {
          nonFormElement : true,
          elementType    : 'span',
          wrapperClass   : 'col-6',
          attributes     : {}
        },
        sectionKey : {
          nonFormElement : true,
          elementType    : 'div',
          wrapperClass   : 'col-6',
          attributes     : {
            id    : 'section-key-column',
            class : ['section_key'],
            html  : 'MEDICATIONS.V2.DISPLAY.LABEL.TABLE_KEY <span class="cmt__key-item cmt__key--error icon--error"> MEDICATIONS.V2.DISPLAY.LABEL.MEDICATION_ERROR</span>'
          }
        }
      }
    },
    columnTitleRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : ['meds-title-row', 'column-title-row', 'grid-row'],
      attributes   : {
        id : 'column-title-row'
      },
      inputChildren : {
        administeredColumn : {
          nonFormElement : true,
          elementType    : 'h4',
          wrapperClass   : 'col-6',
          attributes     : {
            id    : 'administered-column-title',
            class : ['column-title', 'fobu__h4--alignleft'],
            html  : 'MEDICATIONS.V2.DISPLAY.SUBHEADING.DRUG_ADMINISTERED'
          }
        },
        intendedColumn : {
          nonFormElement : true,
          elementType    : 'h4',
          wrapperClass   : 'col-6',
          attributes     : {
            id    : 'intended-column-title',
            class : ['column-title', 'fobu__h4--alignleft'],
            html  : 'MEDICATIONS.V2.DISPLAY.SUBHEADING.DRUG_INTENDED'
          }
        }
      }
    },
    administeredId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name  : 'administeredId',
        class : 'INC-medications__administered-field'
      }
    },
    intendedId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name  : 'intendedId',
        class : 'INC-medications__intended-field'
      }
    },
    drugRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'drug-row'
      },
      inputChildren : {
        administeredDrug : {
          // elementType : 'input, // defaults to input
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED',
          labelFor      : false,
          labelClass    : ['col--no-margin', 'col-12'],
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredDrug',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedDrug : {
          // elementType : 'input, // defaults to input
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredDrug'
            }
          },
          attributes   : {
            name  : 'intendedDrug',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    brandRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'brand-row'
      },
      inputChildren : {
        administeredBrand : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_BRAND',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredBrand',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedBrand : {
          elementType  : 'hiddenWithText',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_BRAND',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredBrand'
            }
          },
          attributes   : {
            name  : 'intendedBrand',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    manufacturerRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'manufacturer-row'
      },
      inputChildren : {
        administeredManufacturer : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_MANUFACTURER',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name     : 'administeredManufacturer',
            disabled : 'disabled',
            class    : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          },
        },
        intendedManufacturer : {
          elementType  : 'hiddenWithText',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_MANUFACTURER',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredManufacturer'
            }
          },
          attributes   : {
            name     : 'intendedManufacturer',
            disabled : 'disabled',
            class    : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    classRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'class-row'
      },
      inputChildren : {
        administeredClass : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_CLASS',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name     : 'administeredClass',
            disabled : 'disabled',
            class    : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedClass : {
          elementType  : 'hiddenWithText',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_CLASS',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredClass'
            }
          },
          attributes   : {
            name     : 'intendedClass',
            disabled : 'disabled',
            class    : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    strengthRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'class-row'
      },
      inputChildren : {
        administeredClass : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_STRENGTH',
          labelClass    : ['col--no-margin', 'col--no-padding'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name     : 'administeredStrength',
            disabled : 'disabled',
            class    : ['INC-medications__administered-field', 'col--no-margin', 'col--no-padding', 'col-12', 'cmt-data-value']
          }
        },
        intendedClass : {
          elementType  : 'hiddenWithText',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_STRENGTH',
          labelClass   : ['col--no-margin', 'col--no-padding'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredStrength'
            }
          },
          attributes   : {
            name     : 'intendedStrength',
            disabled : 'disabled',
            class    : ['INC-medications__intended-field', 'col--no-margin', 'col--no-padding', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    supplierRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'class-row'
      },
      inputChildren : {
        administeredClass : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_SUPPLIER',
          labelClass    : ['col--no-margin', 'col--no-padding'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name     : 'administeredSupplier',
            disabled : 'disabled',
            class    : ['INC-medications__administered-field', 'col--no-margin', 'col--no-padding', 'col-12', 'cmt-data-value']
          }
        },
        intendedClass : {
          elementType  : 'hiddenWithText',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_SUPPLIER',
          labelClass   : ['col--no-margin', 'col--no-padding'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredSupplier'
            }
          },
          attributes   : {
            name     : 'intendedSupplier',
            disabled : 'disabled',
            class    : ['INC-medications__intended-field', 'col--no-margin', 'col--no-padding', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    typeRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'type-row'
      },
      inputChildren : {
        administeredType : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_TYPE',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name     : 'administeredType',
            disabled : 'disabled',
            class    : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedType : {
          elementType  : 'hiddenWithText',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_TYPE',
          labelClass   : ['col--no-margin', 'col-12'],
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredType'
            }
          },
          attributes   : {
            name     : 'intendedType',
            disabled : 'disabled',
            class    : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
      }
    },
    sourceIdRow : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false, // prevent attempting to fetch from graphql, as is the default for properties that use globalSwitch
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'source-id-row'
      },
      inputChildren : {
        administeredSourceId : {
          elementType   : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_SOURCE_ID',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name     : 'administeredSourceId',
            disabled : 'disabled',
            class    : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedSourceId : {
          elementType  : 'hiddenWithText',
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_SOURCE_ID',
          labelClass   : ['col--no-margin', 'col-12'],
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredSourceId'
            }
          },
          attributes   : {
            name     : 'intendedSourceId',
            disabled : 'disabled',
            class    : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
      }
    },
    routeRow : {
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'drug-row'
      },
      inputChildren : {
        administeredAdministrationRoute : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_ROUTE',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredAdministrationRoute',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedAdministrationRoute : {
          elementType  : 'hiddenWithText',
          page         : 0,
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_ROUTE',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredAdministrationRoute'
            }
          },
          attributes   : {
            name  : 'intendedAdministrationRoute',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          },
        },
      }
    },
    doseRow : {
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'dose-row'
      },
      inputChildren : {
        administeredAdministrationDosage : {
          page         : 0,
          elementType  : 'combo',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_ADMINISTERED_DOSAGE',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          attributes   : {
            name : 'administeredAdministrationDosage'
          },
          inputChildren : {
            administeredAdministrationDosageValue : {
              elementType      : 'hiddenWithText',
              comboParent      : 'administeredAdministrationDosage',
              inputLayoutClass : ['col-8', 'col--no-margin'],
              attributes       : {
                name  : 'administeredAdministrationDosageValue',
                class : ['INC-medications__administered-field', '__display--inline', 'cmt-data-value']
              }
            },
            administeredAdministrationDosageUnit : {
              elementType      : 'hiddenWithText',
              comboParent      : 'administeredAdministrationDosage',
              inputLayoutClass : ['col-4', 'col--no-margin'],
              attributes       : {
                name  : 'administeredAdministrationDosageUnit',
                class : ['INC-medications__administered-field', '__display--inline', '__combo-field--display', 'cmt-data-value']
              }
            }
          }
        },
        intendedAdministrationDosage : {
          page         : 1,
          elementType  : 'combo',
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DRUG_INTENDED_DOSAGE',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          attributes   : {
            name : 'intendedAdministrationDosage'
          },
          inputChildren : {
            intendedAdministrationDosageValue : {
              elementType      : 'hiddenWithText',
              comboParent      : 'intendedAdministrationDosage',
              inputLayoutClass : ['col-8', 'col--no-margin'],
              attributes       : {
                name  : 'intendedAdministrationDosageValue',
                class : ['INC-medications__intended-field', '__display--inline',  'cmt-data-value']
              }
            },
            intendedAdministrationDosageUnit : {
              elementType      : 'hiddenWithText',
              comboParent      : 'intendedAdministrationDosage',
              inputLayoutClass : ['col-4', 'col--no-margin'],
              attributes       : {
                name  : 'intendedAdministrationDosageUnit',
                class : ['INC-medications__intended-field', '__display--inline', '__combo-field--display', 'cmt-data-value']
              },
              processInputs : {
                compareTo : {
                  styleTarget     : 'administeredAdministrationDosageValue',
                  compareMultiple : [
                    ['administeredAdministrationDosageValue', 'administeredAdministrationDosageUnit'],
                    ['intendedAdministrationDosageValue', 'intendedAdministrationDosageUnit']
                  ]
                }
              }
            }
          }
        }
      }
    },
    formRow : {
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        administeredFormAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.FORM_ADMINISTERED',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredFormAdministered',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedFormAdministered : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'MEDICATIONS.V2.DISPLAY.LABEL.FORM_INTENDED',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredFormAdministered'
            }
          },
          attributes   : {
            name  : 'intendedFormAdministered',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    reportToManufacturerRow : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        reportedToManufacturer : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.REPORTED_TO_MANUFACTURER',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'reportedToManufacturer',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    dateReportedToManufacturer : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        dateReportedToManufacturer : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.DATE_REPORTED_TO_MANUFACTURER',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'dateReportedToManufacturer',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    manufacturerRef : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        manufacturerRef : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.MANUFACTURER_REF',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'manufacturerRef',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    isStillAdministered : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.STILL_ADMINISTERED',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'isStillAdministered',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    frequency : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.FREQUENCY',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'frequency',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    productExpiryDate : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.PRODUCT_EXPIRY_DATE',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'productExpiryDate',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    actionTaken : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.ACTION_TAKEN',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'actionTaken',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    adrLessened : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.ADR_LESSENED',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'adrLessened',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    adrReappeared : {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false,
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'MEDICATIONS.V2.DISPLAY.LABEL.ADR_REAPPEARED',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'adrReappeared',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    bnfClassificationRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'bnfClassification',
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'bnfclassification-row'
      },
      inputChildren : {
        administeredBnfClassification : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'Drug administered or omitted BNF classification',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredBnfClassification',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedBnfClassification : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'Drug intended BNF classification',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredBnfClassification'
            }
          },
          attributes   : {
            name  : 'intendedBnfClassification',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    batchNumberRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'batchNumber',
      elementType  : 'multicolumn',
      labelFor     : 'administeredBatchNumber',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'batchnumber-row'
      },
      inputChildren : {
        administeredBnfClassificationAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'Drug administered or omitted batch number',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredBatchNumber',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedBnfClassificationAdministered : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'Intended drug batch number',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredBatchNumber'
            }
          },
          attributes   : {
            name  : 'intendedBatchNumber',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    ethicsCommitteeNameReferenceRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'ethicsCommitteeNameReference',
      elementType  : 'multicolumn',
      labelFor     : 'administeredEthicsCommitteeNameReference',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'ethicscommitteenamereference-row'
      },
      inputChildren : {
        administeredBnfClassificationAdministered : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'Drug administered or omitted ethics committee name and reference',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredEthicsCommitteeNameReference',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedBnfClassificationAdministered : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'Drug intended ethics committee name and reference',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredEthicsCommitteeNameReference'
            }
          },
          attributes   : {
            name  : 'intendedEthicsCommitteeNameReference',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    clinicalTrialRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'clinicalTrial',
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'clinicalTrial-row'
      },
      inputChildren : {
        administeredClinicalTrial : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'Is the drug administered or omitted under clinical trial?',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredClinicalTrial',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedClinicalTrial : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'Is the drug intended under clinical trial?',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredClinicalTrial'
            }
          },
          attributes   : {
            name  : 'intendedClinicalTrial',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    manufacturedSpecialRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'manufacturedSpecial',
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'manufacturedSpecial-row'
      },
      inputChildren : {
        administeredManufacturedSpecial : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'Is the drug administered or omitted a manufactured special?',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredManufacturedSpecial',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedManufacturedSpecial : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'Is the drug intended a manufactured special?',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredManufacturedSpecial'
            }
          },
          attributes   : {
            name  : 'intendedManufacturedSpecial',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    parallelImportRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'parallelImport',
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'parallelimport-row'
      },
      inputChildren : {
        administeredParallelImport : {
          elementType   : 'hiddenWithText',
          page          : 0,
          label         : 'Is the drug administered or omitted a parallel import?',
          labelClass    : ['col--no-margin', 'col-12'],
          labelFor      : false,
          wrapperClass  : 'col-6',
          attributes   : {
            name  : 'administeredParallelImport',
            class : ['INC-medications__administered-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        },
        intendedParallelImport : {
          elementType  : 'hiddenWithText',
          page         : 1,
          label        : 'Is the drug intended a parallel import?',
          labelClass   : ['col--no-margin', 'col-12'],
          labelFor     : false,
          wrapperClass : 'col-6',
          processInputs : {
            compareTo : {
              comparator : 'administeredParallelImport'
            }
          },
          attributes   : {
            name  : 'intendedParallelImport',
            class : ['INC-medications__intended-field', 'col--no-margin', 'col-12', 'cmt-data-value']
          }
        }
      }
    },
    stageErrorOccurred : {
      elementType  : 'hiddenWithText',
      page         : 0,
      label        : 'MEDICATIONS.V2.DISPLAY.LABEL.STAGE_ERROR_OCCURED',
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value', 'grid-row-border-top'],
      attributes   : {
        name  : 'stageErrorOccurred',
        class : 'col-12'
      }
    },
    typeOfError : {
      elementType  : 'hiddenWithText',
      page         : 0,
      label        : 'MEDICATIONS.V2.DISPLAY.LABEL.ERROR_TYPE',
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value'],
      attributes   : {
        name  : 'typeOfError',
        class : 'col-12'
      }
    },
    notes : {
      elementType  : 'hiddenWithText',
      page         : 0,
      label        : 'MEDICATIONS.V2.DISPLAY.LABEL.NOTES',
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value'],
      attributes   : {
        name  : 'notes',
        class : 'col-12'
      }
    },
    importantFactors : {
      elementType  : 'hiddenWithText',
      page         : 0,
      label        : 'MEDICATIONS.V2.DISPLAY.LABEL.OTHER_IMPORTANT_FACTORS',
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value'],
      attributes   : {
        name  : 'importantFactors',
        class : 'col-12'
      }
    },
    dateFirstUsedRow: {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false, // prevent attempting to fetch from graphql, as is the default for properties that use globalSwitch
      elementType  : 'hiddenWithText',
      page         : 0,
      label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DATE_FIRST_USED',
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value'],
      attributes   : {
        name  : 'dateFirstUsed',
        class : 'col-12'
      }
    },
    dateLastUsedRow: {
      globalSwitch : 'vanessasLawEnabled',
      optional     : false, // prevent attempting to fetch from graphql, as is the default for properties that use globalSwitch
      elementType  : 'hiddenWithText',
      page         : 0,
      label        : 'MEDICATIONS.V2.DISPLAY.LABEL.DATE_LAST_USED',
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value'],
      attributes   : {
        name  : 'dateLastUsed',
        class : 'col-12'
      }
    },

    adrDateReactionStarted: {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_DATE_REACTION_STARTED',
      visibility  : false
    },
    adrDateReactionStopped: {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_DATE_REACTION_STOPPED',
      visibility  : false
    },
    frequencyWrong : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.FREQUENCY_WRONG',
      visibility  : false
    },
    drugReaction : {
      label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_REACTION',
      visibility  : false
    },
    errorDetectedBy : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ERROR_DETECTED_BY',
      visibility  : false
    },
    errorCommittedBy : {
      label      : 'MEDICATIONS.V2.FORM.LABEL.ERROR_COMMITTED_BY',
      visibility : false,
    },
    didDrugReactionReappear : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.DID_DRUG_REACTION_REAPPEAR',
      visibility  : false
    },
    adrOrganSystem : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_ORGAN_SYSTEM',
      visibility  : false,
    },
    naranjoTotalScore : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.NARANJO_TOTAL_SCORE',
      visibility  : false,
      options: naranjoTotalScore
    },
    adrActionTaken : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_ACTION_TAKEN',
      visibility  : false
    },

    editBottomRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : ['grid-row', 'grid-row-border-top'],
      attributes   : {
        id : 'button-bottom-row'
      },
      inputChildren : {
        deleteRowBottom : {
          elementType  : 'button',
          wrapperClass : 'col-4',
          onClick      : 'deleteButtonAction',
          attributes   : {
            id    : 'delete-row-bottom',
            name    : 'delete-row-bottom',
            class : ['dtx-button', 'dtx-button-small', 'button-warning'],
            html  : 'MEDICATIONS.V2.DISPLAY.BUTTON.DELETE_MEDICATION',
            type: 'button'
          }
        },
        emptyColumn : {
          nonFormElement : true,
          elementType    : 'span',
          wrapperClass: ['col-4', 'edit-row-bottom-message'],
          attributes: {
            html: txt.medication_editing_disabled
          }
        },
        editRowBottom : {
          elementType  : 'button',
          wrapperClass : 'col-4',
          onClick      : 'createNewEditForm',
          attributes   : {
            id    : 'edit-row-bottom',
            name    : 'edit-row-bottom',
            class : ['dtx-button', 'dtx-button-small', 'button-secondary', 'cmt__button--edit-form', ],
            html  : 'MEDICATIONS.V2.DISPLAY.BUTTON.EDIT_MEDICATION',
            type: 'button'
          }
        }
      }
    }
  };

  var visibleFields = getVisibleClientFields();

  function setVisibility(rowName) {
    var isVisible = visibleFields.indexOf(rowName) > -1;
    if (!isVisible && structure[rowName].inputChildren) {
      Object
        .entries(structure[rowName].inputChildren)
        .forEach(function (entry) {
          const childConfig = entry[1];
          if (childConfig.attributes) {
            childConfig.attributes.required = false;
          }
          if (typeof childConfig.validation === 'object') {
            childConfig.validation.required = false;
          }
        });
    }
    structure[rowName].visibility = isVisible;
    return rowName;
  }

  // Function which filters based upon SPSC fieldset
  function filterBySpscFieldset(completeStructure, key) {
    if (spscFields.indexOf(key) != -1) {
      return completeStructure;
    }
    delete completeStructure[key];
    return completeStructure;
  }

  function assignDefaultProprties(completeStructure, key) {
    completeStructure[key] = Object.assign({
      elementType  : 'hiddenWithText',
      page         : 0,
      labelClass   : 'col-12',
      labelFor     : false,
      wrapperClass : ['grid-row', 'cmt-data-value'],
      attributes   : Object.assign({
        name  : key,
        class : 'col-12'
      }, completeStructure[key].attributes || {})
    }, completeStructure[key]);

    return completeStructure;
  }

  if (globals.spscFieldset) {
    var spscFields = [
      'administeredDrugId',
      'administeredHeading',
      'answersId',
      'brandRow',
      'columnTitleRow',
      'dataViewRecordIndex',
      'doseRow',
      'drugRow',
      'formRow',
      'reportToManufacturerRow',
      'dateReportedToManufacturer',
      'manufacturerRef',
      'isStillAdministered',
      'intendedDrugId',
      'manufacturerRow',
      'routeRow',
      'adrId',
      'adrDateReactionStarted',
      'adrDateReactionStopped',
      'frequencyWrong',
      'drugReaction',
      'errorDetectedBy',
      'errorCommittedBy',
      'didDrugReactionReappear',
      'adrOrganSystem',
      'naranjoTotalScore',
      'adrActionTaken',
      'strengthRow',
      'supplierRow',
      'editBottomRow',
      'sourceIdRow',
      'dateFirstUsedRow',
      'dateLastUsedRow',
      'frequency',
      'productExpiryDate',
      'actionTaken',
      'adrLessened',
      'adrReappeared',
    ];

    Object.keys(structure).reduce(filterBySpscFieldset, structure);
  }

  Object.keys(structure)
    .map(setVisibility)
    .reduce(assignDefaultProprties, structure);

  return structure;
}

module.exports = formBuilderStructure;
